<template>
  <v-progress-linear 
    v-if="reportProjects === null"
    indeterminate
    color="green"
  />

  <div class="row" v-else>
    <v-tabs grow v-model="tab">
      <v-tab v-for="tab of tabs" :key="tab.id">
        {{tab.name}}
      </v-tab>
    </v-tabs>

   <v-tabs-items v-model="tab">
      <v-tab-item :key="0">
          <v-card class="mt-5">
            <v-data-table
                :headers="headers"
                :items="reportProjects"
                :items-per-page="reportProjects.length"
                :loading="loading"
                loading-text="Загрузка..."
                no-data-text="Ничего не найдено"
                hide-default-footer
            >
            </v-data-table>
          </v-card>
      </v-tab-item>

      <v-tab-item :key="1">
          <v-card class="mt-5">
            <v-data-table
                :headers="headersWeek"
                :items="reportProjectsWeekAll"
                :items-per-page="reportProjectsWeekAll.length"
                :loading="loading"
                loading-text="Загрузка..."
                no-data-text="Ничего не найдено"
                hide-default-footer
            >
            </v-data-table>
          </v-card>
      </v-tab-item>

      <v-tab-item :key="2">
          <v-card class="mt-5">
            <v-data-table
                :headers="droppedСallsHeaders"
                :items="droppedСallsReport"
                :items-per-page="droppedСallsReport.length"
                :loading="loading"
                loading-text="Загрузка..."
                no-data-text="Ничего не найдено"
                hide-default-footer
            >
            </v-data-table>
          </v-card>
      </v-tab-item>
    </v-tabs-items>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex"

export default {
  name: "QualityInfo",
  props: {
    sip: String,
    period: Array,
  },
  data: function () {
    return {
      showPlayer: false,
      callInfoType: 'default',

      tab: '',
      tabs: [
        {
          id: 0,
          name: 'По проектам',
        },

        {
          id: 1,
          name: 'Понедельная прогрессия',
        },

        {
          id: 2,
          name: 'Сбросы',
        },
      ],

      current_week: 0,
      headers: [
        {
          text: "Проект",
          value: "project_name",
        },
        {
          text: "ФИО оператора",
          value: "user_name",
        },
        {
          text: "Колво сбросов, шт.",
          value: "dropped_calls_count",
        },
        {
          text: "Колво зависших каналов оператора, шт.",
          value: "hung_calls_count",
        },
        {
          text: "Колво игноров, шт.",
          value: "ignored_calls_count",
        },
        {
          text: "Кол-во офф. претензий, шт.",
          value: "remarks_count",
        },
        {
          text: "Колво благодарностей, шт.",
          value: "gratitude_count",
        },
        {
          text: "Средний КЛН, балл",
          value: "avg_kln",
        },
        {
          text: "Среднее время разговора, сек",
          value: "avg_duration_sec",
        },
        {
          text: "Колво длинных холдов, шт.",
          value: "long_hold_count",
        },
        {
          text: "Выговоренные минуты",
          value: "sum_duration_min",
        },
        {
          text: "Колво звонков обработанных операторов, шт",
          value: "calls_count",
        },
      ],
      headersWeek: [
        {
          text: "Неделя",
          value: "week_num",
        },
        {
          text: "ФИО оператора",
          value: "user_name",
        },
        {
          text: "Колво сбросов, шт.",
          value: "dropped_calls_count",
        },
        {
          text: "Колво зависших каналов оператора, шт.",
          value: "hung_calls_count",
        },
        {
          text: "Колво игноров, шт.",
          value: "ignored_calls_count",
        },
        {
          text: "Кол-во офф. претензий, шт.",
          value: "remarks_count",
        },
        {
          text: "Колво благодарностей, шт.",
          value: "gratitude_count",
        },
        {
          text: "Средний КЛН, балл",
          value: "avg_kln",
        },
        {
          text: "Среднее время разговора, сек",
          value: "avg_duration_sec",
        },
        {
          text: "Колво длинных холдов, шт.",
          value: "long_hold_count",
        },
        {
          text: "Выговоренные минуты",
          value: "sum_duration_min",
        },
        {
          text: "Колво звонков обработанных операторов, шт",
          value: "calls_count",
        },
      ],

      droppedСallsHeaders: [
        {
          text: "Номер телефона",
          value: "client_phone",
        },
        {
          text: "Дата и время вызова",
          value: "t1",
        },
        {
          text: "Линия",
          value: "queue",
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      hasPermission: "user/hasPermission",
      reportProjects: 'operators/reportProjects',
      reportProjectsWeek1: 'operators/reportProjectsWeek1',
      reportProjectsWeek2: 'operators/reportProjectsWeek2',
      reportProjectsWeek3: 'operators/reportProjectsWeek3',
      reportProjectsWeek4: 'operators/reportProjectsWeek4',
      reportProjectsWeekAll: 'operators/reportProjectsWeekAll',
      droppedСallsReport: 'operators/droppedСallsReport',
      loading: "shared/getLoading",
    }),
  },

  watch: {
    sip(newVal) {
      if (newVal !== null) {
        this.loadQualityByProjects({agents: [this.sip], period: this.period, by_projects: true});
        this.loadDroppedCallsReport({agent: this.sip, period: this.period});
        this.loadQualityByProjectsWeek1({agents: [this.sip], period: this.period, by_projects: true});
        this.loadQualityByProjectsWeek2({agents: [this.sip], period: this.period, by_projects: true});
        this.loadQualityByProjectsWeek3({agents: [this.sip], period: this.period, by_projects: true});
        this.loadQualityByProjectsWeek4({agents: [this.sip], period: this.period, by_projects: true});
        this.loadQualityByProjectsWeek4({agents: [this.sip], period: this.period, by_projects: true});
      }
    },
  },

  mounted() {
    if (this.sip !== null) {
      this.loadQualityByProjects({agents: [this.sip], period: this.period, by_projects: true});
      this.loadDroppedCallsReport({agent: this.sip, period: this.period});
      this.loadQualityByProjectsWeek1({agents: [this.sip], period: this.period, by_projects: true});
      this.loadQualityByProjectsWeek2({agents: [this.sip], period: this.period, by_projects: true});
      this.loadQualityByProjectsWeek3({agents: [this.sip], period: this.period, by_projects: true});
      this.loadQualityByProjectsWeek4({agents: [this.sip], period: this.period, by_projects: true});
    }
  },
  methods: {
    ...mapActions({
      loadQualityByProjects: 'operators/loadQualityByProjects',
      loadQualityByProjectsWeek1: 'operators/loadQualityByProjectsWeek1',
      loadQualityByProjectsWeek2: 'operators/loadQualityByProjectsWeek2',
      loadQualityByProjectsWeek3: 'operators/loadQualityByProjectsWeek3',
      loadQualityByProjectsWeek4: 'operators/loadQualityByProjectsWeek4',
      loadQualityOperatorsReport: 'operators/loadQualityOperatorsReport',
      clearQualityByProjects: 'operators/clearQualityByProjects',
      loadDroppedCallsReport: 'operators/loadDroppedCallsReport',
    }),
    
    // tabWeek(ev, index) {
    //   ev;
    //   index;
    //   this.current_week = index
    // }
  },

  beforeDestroy() {
    this.clearQualityByProjects();
  }
}
</script>

<style scoped lang="scss">

$variable-prefix:             bs- !default;
$border-width:                1px !default;
$border-radius:               .25rem !default;
$body-text-align:           null !default;
$white:    #fff !default;
$gray-100: #f8f9fa !default;
$gray-200: #e9ecef !default;
$gray-300: #dee2e6 !default;
$gray-400: #ced4da !default;
$gray-500: #adb5bd !default;
$gray-600: #6c757d !default;
$gray-700: #495057 !default;
$gray-800: #343a40 !default;
$gray-900: #212529 !default;
$black:    #000 !default;

$body-bg:                   $white !default;
$body-color:                $gray-900 !default;

$blue:    #0d6efd !default;
$primary:       $blue !default;
$link-color:                              $primary !default;
$link-shade-percentage:                   20% !default;
$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;
$link-decoration:                         underline !default;
$link-hover-decoration:                   null !default;

$component-active-color:      $white !default;
$component-active-bg:         $primary !default;

// Navs

// scss-docs-start nav-variables
$nav-link-padding-y:                .25rem !default;
$nav-link-padding-x:                .55em !default;
$nav-link-font-size:                null !default;
$nav-link-font-weight:              null !default;
$nav-link-color:                    $link-color !default;
$nav-link-hover-color:              $link-hover-color !default;
$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;
$nav-link-disabled-color:           $gray-600 !default;

$nav-tabs-border-color:             $gray-300 !default;
$nav-tabs-border-radius:            $border-radius !default;
$nav-tabs-border-width:             1px !default;
$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;
$nav-tabs-link-active-color:        $gray-700 !default;
$nav-tabs-link-active-bg:           $body-bg !default;
$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;

$nav-pills-border-radius:           $border-radius !default;
$nav-pills-link-active-color:       $component-active-color !default;
$nav-pills-link-active-bg:          $component-active-bg !default;

// Base class
//
// Kickstart any navigation component with a set of style resets. Works with
// `<nav>`s, `<ul>`s or `<ol>`s.

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: $nav-link-padding-y $nav-link-padding-x;
  font-weight: $nav-link-font-weight;
  color: $nav-link-color;
  text-decoration: if($link-decoration == none, null, none);

  &:hover,
  &:focus {
    color: $nav-link-hover-color;
    text-decoration: if($link-hover-decoration == underline, none, null);
  }

  // Disabled state lightens text
  &.disabled {
    color: $nav-link-disabled-color;
    pointer-events: none;
    cursor: default;
  }
}

//
// Tabs
//

.nav-tabs {
  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;

  .nav-link {
    margin-bottom: -$nav-tabs-border-width;
    background: none;
    border: $nav-tabs-border-width solid transparent;

    &:hover,
    &:focus {
      border-color: $nav-tabs-link-hover-border-color;
      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link
      isolation: isolate;
    }

    &.disabled {
      color: $nav-link-disabled-color;
      background-color: transparent;
      border-color: transparent;
    }
  }

  .nav-link.active,
  .nav-item.show .nav-link {
    color: $nav-tabs-link-active-color;
    background-color: $nav-tabs-link-active-bg;
    border-color: $nav-tabs-link-active-border-color;
  }

  .dropdown-menu {
    // Make dropdown border overlap tab border
    margin-top: -$nav-tabs-border-width;
    // Remove the top rounded corners here since there is a hard edge above the menu
  }
}

//
// Pills
//

.nav-pills {
  .nav-link {
    background: none;
    border: 0;
  }

  .nav-link.active,
  .show > .nav-link {
    color: $nav-pills-link-active-color;
  }
}

//
// Justified variants
//

.nav-fill {
  > .nav-link,
  .nav-item {
    flex: 1 1 auto;
    text-align: center;
  }
}

.nav-justified {
  > .nav-link,
  .nav-item {
    flex-basis: 0;
    flex-grow: 1;
    text-align: center;
  }
}

.nav-fill,
.nav-justified {
  .nav-item .nav-link {
    width: 100%; // Make sure button will grow
  }
}

// Tabbable tabs
//
// Hide tabbable panes to start, show them when `.active`

.tab-content {
  > .tab-pane {
    display: none;
  }
  > .active {
    display: block;
  }
}

tbody, td, tfoot, th, thead, tr {
    border-color: inherit;
    border-style: solid;
    border-width: 0;
}

.table-bordered>:not(caption)>* {
    border-width: 1px 0;
}

.table-bordered>:not(caption)>*>* {
    border-width: 0 1px;
}

.table>:not(caption)>*>* {
    padding: 0.5rem 0.5rem;
    border-bottom-width: 1px;
}

.table td {
  padding: 0.5rem 0.5rem;
  border: 1px solid #dee2e6;
}

.table {
    margin-bottom: 1rem;
    color: #212529;
    vertical-align: top;
    border-color: #dee2e6;
    caption-side: bottom;
    border-collapse: collapse;
}

</style>
